import GuardianSick from './GuardianSick'

export default GuardianSick;
